const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chart-bars-16px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    id: "Path_152",
    "data-name": "Path 152",
    d: "M-1.5,15H-2V5.5A.5.5,0,0,0-2.5,5h-3a.5.5,0,0,0-.5.5V8H-8V2.5A.5.5,0,0,0-8.5,2h-3a.5.5,0,0,0-.5.5V11h-2.5a.5.5,0,0,0-.5.5V15h-1V.5a.5.5,0,0,0-.5-.5.5.5,0,0,0-.5.5v15a.5.5,0,0,0,.5.5h15a.5.5,0,0,0,.5-.5A.5.5,0,0,0-1.5,15ZM-14,12h2v3h-2Zm3-.5V3h2V15h-2ZM-8,9h2v6H-8Zm3,6V6h2v9Z",
    transform: "translate(17)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChart);
export default __webpack_public_path__ + "static/media/icon_chart.6f0c2fe1633a1f466f288f331c4a0c7c.svg";
export { ForwardRef as ReactComponent };